module.exports = {"data":{"contentfulAbout":{"phone":"647 381 1436","email":"hello@nelshuang.com","instagram":"nelshuang","aboutParagraph":{"aboutParagraph":"Aspiring Super Saiyan. My hair is black now, but contact me for further updates. \n\nToronto based Photographer.\n"}}},"pathContext":{"_PARENT":"SOURCE"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 320
// module chunks = 273950069227526